import React, { Component } from "react";
import { connect } from "react-redux";
import { setActiveModule } from "../../actions/sideBarActions";
import NavbarContainer from "../Navbar/NavbarContainer";
import { allowedCompanies } from "../Sidebar/Menu/companyAccessToSf";
import "./NotAnAdmin.scss";

class NotAnAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterAndIntegrationDisabled: false,
        };
    }
    componentDidMount() {
        // this.props.setModule();
        // let allowedCompanies = [10201, 12087, 12108, 11188, 12201, 12259];

        if (
            ["social-response/integrations", "social-response/filters"].some((url) => window.location.pathname.includes(url)) &&
            !allowedCompanies.includes(this.props.company.company_lite_company_id)
        ) {
            // if (!allowedCompanies.includes(this.props.company.company_lite_company_id))
            this.setState({ filterAndIntegrationDisabled: true });
        }
    }

    render() {
        return (
            <div className={`not-an-admin ${this.props?.className}`}>
                <NavbarContainer history={this.props.history} location={this.props.location} />
                <div className="message">
                    {this.state.filterAndIntegrationDisabled || this.props.settingsDisabled ? (
                        <p>
                            You do not have access to this feature, please reach out to our{" "}
                            <a href="mailto: support@radarr.com" target="_newtab">
                                support
                            </a>{" "}
                            for further information.
                        </p>
                    ) : this.props.companyLevelAccessDenied ? (
                        <p>
                            You do not have access to this module, please reach out to our{" "}
                            <a href="mailto: support@radarr.com" target="_newtab">
                                support
                            </a>{" "}
                            for further information.
                        </p>
                    ) : (
                        <p>You are not an admin. So you don&apos;t have access to these pages</p>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        company: state.globalReducer.company,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setModule: () => dispatch(setActiveModule(null)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotAnAdmin);
